<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <h4>แก้ไขรัหัสผ่าน</h4>
      </b-card-header>
      <b-card-body>
        <b-form>
          <b-row>
            <b-col cols="12">
              <b-form-group
                class="font-weight-slim"
                label="ชื่อผู้ใช้ :"
                label-cols-md="3"
              >
               <div class="d-flex align-items-center">
                 <span>{{this.username}}</span>
               </div>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                class="font-weight-slim"
                label="รหัสผ่านเก่า :"
                label-cols-md="3"
              >
                <div class="d-flex align-items-center">
                  <b-form-input v-model="oldPassword" class="col-md-6"/>
                  <span class="pl-1" v-if="this.updateFail == 'รหัสผ่านเก่าไม่ถูกต้อง'" style="color:red">{{this.updateFail}}</span>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                class="font-weight-slim"
                label="รหัสผ่านใหม่ :"
                label-cols-md="3"
              >
                <div class="d-flex align-items-center">
                  <b-form-input v-model="newPassword" class="col-md-6"/>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer>
        <b-button variant="outline-secondary" :to="{ name: 'me-information'}">{{"<<ย้อนกลับ"}}</b-button>
        <b-button class="ml-1" variant="primary" @click="updatePassword()" :disabled="this.loadButton == false">
          <b-spinner v-if="this.loadButton == false" small />
          ยืนยัน
        </b-button>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>

import {
  BFormGroup, BFormInput, BButton, BCardBody, BCard, BRow, BCol, BCardHeader, BCardFooter, BForm, BSpinner
} from 'bootstrap-vue'
import {header_token, specify_header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";

const username = JSON.parse(localStorage.getItem('userData'))

export default {
  name: 'Taobao2youUpdatePassword',

  components: {
    BCard, BCardHeader, BCardBody, BCardFooter, BForm, BFormGroup, BRow, BCol, BFormInput, BButton, BSpinner
   },

  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      username: username.data.customerInfo.userName,
      oldPassword: '',
      newPassword: '',
      updateFail: '',

      loadButton: true,
    };
  },

  methods: {
    async updatePassword() {
      this.loadButton = false
      let response = await axios.post(
        taobaoService_dotnet + '/app/Customer/update-customer-password',
        {
          "loginToken": this.userData.data.customerInfo.loginToken,
          "oldPassword": this.oldPassword,
          "newPassword": this.newPassword,
        },
        { headers: specify_header_token }
      );
      if (response.data == 'success') {
        await this.$router.push({ path: '/me/information' });
        this.$swal({
          icon: 'success',
          title: 'แก้ไขรหัสผ่านเรียบร้อย',
          showConfirmButton: false,
          timer: 2500,
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      } else {
        this.updateFail = response.data
      }
      this.loadButton = true
    },
  },
};
</script>

<style lang="scss" scoped>

</style>